import React from 'react';

const STOCK_RANGES = {
  coldstorage1: { low: 51, medium: 99 },
  coldstorage2: { low: 51, medium: 99 },
  coldstorage3: { low: 51, medium: 99 },
  totems: { low: 50, medium: 101 },
  refrigerators: { low: 20, medium: 50 },
  warehouse: { low: 5, medium: 10 },
};

const LED_COLORS = {
  low: 'bg-red-500 ring-red-500/30',
  medium: 'bg-amber-400 ring-amber-400/30',
  high: 'bg-green-500 ring-green-500/30',
};

const InventoryStockLed = ({ location, quantity }) => {
  const stock = Number(quantity);
  const ranges = STOCK_RANGES[location];

  if (!ranges || !Number.isFinite(stock) || stock < 1) return null;

  const level = stock <= ranges.low ? 'low' : stock <= ranges.medium ? 'medium' : 'high';
  const label = {
    low: 'Inventario bajo',
    medium: 'Inventario en atención',
    high: 'Inventario suficiente',
  }[level];

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={`ml-2 inline-block h-2.5 w-2.5 rounded-full ring-2 ${LED_COLORS[level]}`}
    />
  );
};

export default InventoryStockLed;
